import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import ttmLogoDark from "@/assets/ttm-logo-dark.png";
import ttmLogoLight from "@/assets/ttm-logo-light.png";

const links = [
  { to: "/method", label: "The Method" },
  { to: "/on-leadership", label: "On Tough Trust" },
  { to: "/coaching-pairs", label: "Coaching Pairs" },
  { to: "/about", label: "About Pete" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  const onLight = scrolled || location.pathname !== "/";

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        onLight
          ? "bg-ivory/85 backdrop-blur-xl border-b border-ink/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="container-px flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src={onLight ? ttmLogoDark : ttmLogoLight}
            alt="Tough Trust Method"
            className="h-9 md:h-10 w-auto"
          />
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  onLight ? "text-ink/70 hover:text-windsor" : "text-ivory/80 hover:text-ivory"
                } ${isActive ? "!text-windsor font-medium" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href="mailto:pete@peteashbycoaching.com"
            data-testid="nav-cta-contact"
            className="bg-[#C2410C] text-ivory px-6 py-3 text-sm font-medium tracking-wide hover:bg-windsor-dark transition-colors"
          >
            Contact
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className={`md:hidden ${onLight ? "text-ink" : "text-ivory"}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-ivory border-t border-ink/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.to.replace("/", "")}`}
              className="text-ink/80 text-lg"
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href="mailto:pete@peteashbycoaching.com"
            data-testid="nav-mobile-cta"
            className="bg-[#C2410C] text-ivory px-6 py-3 text-center font-medium"
          >
            Contact
          </a>
        </div>
      )}
    </header>
  );
};
